module.exports = {
      id: "health-usage",
      viewBox: "0 0 26.46 26.46",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#health",
      toString: function () {
        return this.url;
      }
    }